























// vendor
import { defineComponent, computed, ref, inject, ComputedRef } from "@vue/composition-api";
import { format as formatDate } from "date-fns";
// project
import { StudyWidgetGrid } from "@/components.studies/study-widget-grid";
import { StudySessionCalendar } from "@/components.studies/study-session-calendar";
import { StudyContext } from "../StudyContext";

export default defineComponent({
	components:{
		StudyWidgetGrid,
		StudySessionCalendar,
	},
	setup(props, context){
		const studyId = computed(() => {
			return context.root.$route.params["groupId"];
		});

		const studyContext = inject<ComputedRef<StudyContext>>("studyContext");

		if(!studyContext){ throw Error("Study Dashboard: Study context missing!"); }
		
		const {
			study,
			blueprint,
			blueprintVersion,
			channels,
		} = studyContext.value;

		const dateLabel = computed(() => {
			if(!study.value){ return ""; }
			return formatDate(new Date(study.value.created), "EEEE MMM. d, y");
		});

		return {
			studyId,
			dateLabel,
		};
	}
});

